<template lang="pug">
.y-text-field
  v-text-field.top-address(v-model="address.address_1" :label="$t('address_1.label')" filled rounded hide-details :rules="addressRules" :persistent-hint="hint.length > 0" :hint="hint" :readonly="readonly" :validate-on-blur="validateOnBlur" :autofocus="autofocus" :disabled="disabled")
    template(v-if="prependIcon" v-slot:prepend-inner)
      v-icon.mt-n2.mr-2(color="primary400" size="18") {{ prependIcon }}
    template(v-slot:append)
      svg(class="warning-icon" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg")
        path(fill-rule="evenodd" clip-rule="evenodd" d="M8.16602 5.66602C8.16602 5.20602 8.53935 4.83268 8.99935 4.83268C9.45935 4.83268 9.83268 5.20602 9.83268 5.66602V9.83268C9.83268 10.2927 9.45935 10.666 8.99935 10.666C8.53935 10.666 8.16602 10.2927 8.16602 9.83268V5.66602ZM8.16602 12.3327C8.16602 11.8727 8.53935 11.4993 8.99935 11.4993C9.45935 11.4993 9.83268 11.8727 9.83268 12.3327C9.83268 12.7927 9.45935 13.166 8.99935 13.166C8.53935 13.166 8.16602 12.7927 8.16602 12.3327ZM8.99935 15.666C5.32352 15.666 2.33268 12.6752 2.33268 8.99935C2.33268 5.32352 5.32352 2.33268 8.99935 2.33268C12.6752 2.33268 15.666 5.32352 15.666 8.99935C15.666 12.6752 12.6752 15.666 8.99935 15.666ZM8.99935 0.666016C4.39685 0.666016 0.666016 4.39685 0.666016 8.99935C0.666016 13.6018 4.39685 17.3327 8.99935 17.3327C13.6018 17.3327 17.3327 13.6018 17.3327 8.99935C17.3327 4.39685 13.6018 0.666016 8.99935 0.666016Z" fill="var(--v-danger)")
  v-text-field.middle-address(v-model="address.address_2" :label="$t('address_2.label')" filled rounded hide-details :persistent-hint="hint.length > 0" :hint="hint" :readonly="readonly" :validate-on-blur="validateOnBlur" :autofocus="autofocus" :disabled="disabled")
    template(v-if="prependIcon" v-slot:prepend-inner)
      v-icon.mt-n2.mr-2(color="primary400" size="18") {{ prependIcon }}
    template(v-slot:append)
      svg(class="warning-icon" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg")
        path(fill-rule="evenodd" clip-rule="evenodd" d="M8.16602 5.66602C8.16602 5.20602 8.53935 4.83268 8.99935 4.83268C9.45935 4.83268 9.83268 5.20602 9.83268 5.66602V9.83268C9.83268 10.2927 9.45935 10.666 8.99935 10.666C8.53935 10.666 8.16602 10.2927 8.16602 9.83268V5.66602ZM8.16602 12.3327C8.16602 11.8727 8.53935 11.4993 8.99935 11.4993C9.45935 11.4993 9.83268 11.8727 9.83268 12.3327C9.83268 12.7927 9.45935 13.166 8.99935 13.166C8.53935 13.166 8.16602 12.7927 8.16602 12.3327ZM8.99935 15.666C5.32352 15.666 2.33268 12.6752 2.33268 8.99935C2.33268 5.32352 5.32352 2.33268 8.99935 2.33268C12.6752 2.33268 15.666 5.32352 15.666 8.99935C15.666 12.6752 12.6752 15.666 8.99935 15.666ZM8.99935 0.666016C4.39685 0.666016 0.666016 4.39685 0.666016 8.99935C0.666016 13.6018 4.39685 17.3327 8.99935 17.3327C13.6018 17.3327 17.3327 13.6018 17.3327 8.99935C17.3327 4.39685 13.6018 0.666016 8.99935 0.666016Z" fill="var(--v-danger)")
  v-text-field.middle-address(v-model="address.postcode" :label="$t('postcode.label')" filled rounded hide-details type="number" :rules="addressRules" :persistent-hint="hint.length > 0" :hint="hint" :readonly="readonly" :validate-on-blur="validateOnBlur" :autofocus="autofocus" :disabled="disabled" :loading="isLoading" @keyup="fetchPostcodes(address.postcode)")
    template(v-if="prependIcon" v-slot:prepend-inner)
      v-icon.mt-n2.mr-2(color="primary400" size="18") {{ prependIcon }}
    template(v-slot:append)
      svg(class="warning-icon" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg")
        path(fill-rule="evenodd" clip-rule="evenodd" d="M8.16602 5.66602C8.16602 5.20602 8.53935 4.83268 8.99935 4.83268C9.45935 4.83268 9.83268 5.20602 9.83268 5.66602V9.83268C9.83268 10.2927 9.45935 10.666 8.99935 10.666C8.53935 10.666 8.16602 10.2927 8.16602 9.83268V5.66602ZM8.16602 12.3327C8.16602 11.8727 8.53935 11.4993 8.99935 11.4993C9.45935 11.4993 9.83268 11.8727 9.83268 12.3327C9.83268 12.7927 9.45935 13.166 8.99935 13.166C8.53935 13.166 8.16602 12.7927 8.16602 12.3327ZM8.99935 15.666C5.32352 15.666 2.33268 12.6752 2.33268 8.99935C2.33268 5.32352 5.32352 2.33268 8.99935 2.33268C12.6752 2.33268 15.666 5.32352 15.666 8.99935C15.666 12.6752 12.6752 15.666 8.99935 15.666ZM8.99935 0.666016C4.39685 0.666016 0.666016 4.39685 0.666016 8.99935C0.666016 13.6018 4.39685 17.3327 8.99935 17.3327C13.6018 17.3327 17.3327 13.6018 17.3327 8.99935C17.3327 4.39685 13.6018 0.666016 8.99935 0.666016Z" fill="var(--v-danger)")
  v-text-field.middle-address(v-model="address.city" :label="$t('city.label')" filled rounded hide-details :rules="addressRules" :persistent-hint="hint.length > 0" :hint="hint" :readonly="readonly" :validate-on-blur="validateOnBlur" :autofocus="autofocus" :disabled="disabled" :loading="isLoading")
    template(v-if="prependIcon" v-slot:prepend-inner)
      v-icon.mt-n2.mr-2(color="primary400" size="18") {{ prependIcon }}
    template(v-slot:append)
      svg(class="warning-icon" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg")
        path(fill-rule="evenodd" clip-rule="evenodd" d="M8.16602 5.66602C8.16602 5.20602 8.53935 4.83268 8.99935 4.83268C9.45935 4.83268 9.83268 5.20602 9.83268 5.66602V9.83268C9.83268 10.2927 9.45935 10.666 8.99935 10.666C8.53935 10.666 8.16602 10.2927 8.16602 9.83268V5.66602ZM8.16602 12.3327C8.16602 11.8727 8.53935 11.4993 8.99935 11.4993C9.45935 11.4993 9.83268 11.8727 9.83268 12.3327C9.83268 12.7927 9.45935 13.166 8.99935 13.166C8.53935 13.166 8.16602 12.7927 8.16602 12.3327ZM8.99935 15.666C5.32352 15.666 2.33268 12.6752 2.33268 8.99935C2.33268 5.32352 5.32352 2.33268 8.99935 2.33268C12.6752 2.33268 15.666 5.32352 15.666 8.99935C15.666 12.6752 12.6752 15.666 8.99935 15.666ZM8.99935 0.666016C4.39685 0.666016 0.666016 4.39685 0.666016 8.99935C0.666016 13.6018 4.39685 17.3327 8.99935 17.3327C13.6018 17.3327 17.3327 13.6018 17.3327 8.99935C17.3327 4.39685 13.6018 0.666016 8.99935 0.666016Z" fill="var(--v-danger)")
  v-text-field.middle-address(v-model="address.state" :label="$t('state.label')" filled rounded hide-details :rules="addressRules" :persistent-hint="hint.length > 0" :hint="hint" :readonly="readonly" :validate-on-blur="validateOnBlur" :autofocus="autofocus" :disabled="disabled" :loading="isLoading")
    template(v-if="prependIcon" v-slot:prepend-inner)
      v-icon.mt-n2.mr-2(color="primary400" size="18") {{ prependIcon }}
    template(v-slot:append)
      svg(class="warning-icon" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg")
        path(fill-rule="evenodd" clip-rule="evenodd" d="M8.16602 5.66602C8.16602 5.20602 8.53935 4.83268 8.99935 4.83268C9.45935 4.83268 9.83268 5.20602 9.83268 5.66602V9.83268C9.83268 10.2927 9.45935 10.666 8.99935 10.666C8.53935 10.666 8.16602 10.2927 8.16602 9.83268V5.66602ZM8.16602 12.3327C8.16602 11.8727 8.53935 11.4993 8.99935 11.4993C9.45935 11.4993 9.83268 11.8727 9.83268 12.3327C9.83268 12.7927 9.45935 13.166 8.99935 13.166C8.53935 13.166 8.16602 12.7927 8.16602 12.3327ZM8.99935 15.666C5.32352 15.666 2.33268 12.6752 2.33268 8.99935C2.33268 5.32352 5.32352 2.33268 8.99935 2.33268C12.6752 2.33268 15.666 5.32352 15.666 8.99935C15.666 12.6752 12.6752 15.666 8.99935 15.666ZM8.99935 0.666016C4.39685 0.666016 0.666016 4.39685 0.666016 8.99935C0.666016 13.6018 4.39685 17.3327 8.99935 17.3327C13.6018 17.3327 17.3327 13.6018 17.3327 8.99935C17.3327 4.39685 13.6018 0.666016 8.99935 0.666016Z" fill="var(--v-danger)")
  v-text-field.bottom-address(v-model="address.country" :label="$t('country.label')" filled rounded hide-details :rules="addressRules" :persistent-hint="hint.length > 0" :hint="hint" :readonly="readonly" :validate-on-blur="validateOnBlur" :autofocus="autofocus" :disabled="disabled" :loading="isLoading")
    template(v-if="prependIcon" v-slot:prepend-inner)
      v-icon.mt-n2.mr-2(color="primary400" size="18") {{ prependIcon }}
    template(v-slot:append)
      svg(class="warning-icon" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg")
        path(fill-rule="evenodd" clip-rule="evenodd" d="M8.16602 5.66602C8.16602 5.20602 8.53935 4.83268 8.99935 4.83268C9.45935 4.83268 9.83268 5.20602 9.83268 5.66602V9.83268C9.83268 10.2927 9.45935 10.666 8.99935 10.666C8.53935 10.666 8.16602 10.2927 8.16602 9.83268V5.66602ZM8.16602 12.3327C8.16602 11.8727 8.53935 11.4993 8.99935 11.4993C9.45935 11.4993 9.83268 11.8727 9.83268 12.3327C9.83268 12.7927 9.45935 13.166 8.99935 13.166C8.53935 13.166 8.16602 12.7927 8.16602 12.3327ZM8.99935 15.666C5.32352 15.666 2.33268 12.6752 2.33268 8.99935C2.33268 5.32352 5.32352 2.33268 8.99935 2.33268C12.6752 2.33268 15.666 5.32352 15.666 8.99935C15.666 12.6752 12.6752 15.666 8.99935 15.666ZM8.99935 0.666016C4.39685 0.666016 0.666016 4.39685 0.666016 8.99935C0.666016 13.6018 4.39685 17.3327 8.99935 17.3327C13.6018 17.3327 17.3327 13.6018 17.3327 8.99935C17.3327 4.39685 13.6018 0.666016 8.99935 0.666016Z" fill="var(--v-danger)")
</template>

<script>

export default {
  name: 'AddressField',
  model: {
    event: 'change'
  },
  props: {
    value: {
      default: null
    },
    hint: {
      default: ''
    },
    prependIcon: {
      default: ''
    },
    readonly: {
      default: false
    },
    validateOnBlur: {
      default: false
    },
    autofocus: {
      default: false
    },
    required: {
      default: false
    },
    disabled: {
      default: false
    },
    loading: {
      default: false
    }
  },
  data () {
    return {
      isLoading: false,
      address: {},
      rules: {
        not_empty: [v => !!v || 'This field is required'],
      },
    }
  },
  computed: {
    modelValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('change', newValue)
      }
    },
    addressRules () {
      if (this.required) {
        return this.rules.not_empty
      }
      if (!this.checkEmptyAddress(this.address)) {
        return this.rules.not_empty
      }
      return []
    }
  },
  watch: {
    address: {
      deep: true,
      handler (val) {
        this.modelValue = val
      }
    }
  },
  methods: {
    fetchPostcodes (val) {
      if (!val) {
        return
      }
      if (val.length !== 5) {
        return
      }
      this.isLoading = true
      this.$axios.get(`/api/shipping/postcodes?postcode=${val}`).then((response) => {
        const addresses = response.data
        if (addresses.length > 0 && addresses[0].postcode) {
          this.$set(this.address, 'city', addresses[0].city)
          this.$set(this.address, 'state', addresses[0].state)
          this.$set(this.address, 'country', addresses[0].country)
        }
      })
      .catch(() => {
      })
      .finally(() => {
        this.isLoading = false
      })
    },
    checkEmptyAddress (address) {
      if (!address) {
        return true
      }
      if (Object.keys(address).length === 0) {
        return true
      } else if (Object.values(address).every(val => !val)) {
        return true
      }
      return false
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-input .warning-icon {
    display: none;
  }

  .v-input.error--text .warning-icon {
    display: unset !important;
  }

  .v-text-field--rounded>.v-input__control>.v-input__slot {
    padding: 8px 12px;
  }

  .v-text-field>.v-input__control>.v-input__slot>.v-text-field__slot {
    align-items: center;
  }

  .v-text-field--filled {
    .v-input__slot {
      background: #FFF !important;
      border-left: 1px solid var(--v-neutral400) !important;
      border-right: 1px solid var(--v-neutral400) !important;
      // border-radius: 10px;
      max-height: 48px;
      min-height: 48px;
      padding-left: 12px;
    }

    :not(.v-text-field--single-line) input {
      margin-top: auto;
      padding: 0;
    }

    .v-label {
      top: unset !important;
      color: var(--v-neutral500);
      font-weight: 400 !important;
    }

    .v-label--active {
      transform: translateY(-10px) scale(0.75);
      color: var(--v-neutral500);
    }
  }

  .v-input--has-state {
    .v-label {
      color: var(--v-danger) !important;
    }

    .v-input__slot {
      border: 1px solid var(--v-danger) !important;
    }

    .error--text {
      color: var(--v-danger) !important;
    }
  }

  .v-input--has-state.v-input--is-focused {
    .v-label {
      color: var(--v-danger) !important;
    }

    .v-input__slot {
      border: 1.5px solid var(--v-danger) !important;
    }
  }

  .theme--light.v-input input,
  .theme--light.v-input textarea {
    color: #333;
    caret-color: #333;
    font-weight: 500 !important;
    font-size: 16px !important;
    line-height: 24px !important;
  }

  .theme--light.v-input.error--text input,
  .theme--light.v-input.error--text textarea {
    color: var(--v-danger) !important;
    caret-color: var(--v-danger);
  }

  .v-input--is-focused {
    .v-label {
      color: var(--v-neutral500) !important;
    }

    .v-input__slot {
      border: 1.5px solid #333 !important;
    }
  }

  .v-text-field--enclosed .v-input__append-inner {
    margin: auto 0 !important;
  }

  .mdi::before {
    font-size: 20px;
    color: #333;
  }

  .v-text-field .v-input__control .v-input__slot {
    min-height: 56px !important;
    display: flex !important;
  }
  .top-address {
    border-radius: 10px 10px 0 0;
    .v-input__slot {
      border-top: 1px solid var(--v-neutral400) !important;
      border-bottom: 0.5px solid var(--v-neutral400) !important;
    }
  }
  .middle-address {
    border-radius: 0 0 0 0;
    .v-input__slot {
      border-top: 0.5px solid var(--v-neutral400) !important;
      border-bottom: 0.5px solid var(--v-neutral400) !important;
    }
  }
  .bottom-address {
    border-radius: 0 0 10px 10px;
    .v-input__slot {
      border-bottom: 1px solid var(--v-neutral400) !important;
      border-top: 0.5px solid var(--v-neutral400) !important;
    }
  }
}
</style>


<i18n>
{
  "en": {
    "address_1": {
      "label": "Address Line 1",
      "placeholder": "e.g. K-3-01, Conezion, Persiaran IRC3"
    },
    "address_2": {
      "label": "Address Line 2",
      "placeholder": "e.g. IOI Resort City"
    },
    "postcode": {
      "label": "Postcode",
      "placeholder": "e.g. 62502"
    },
    "city": {
      "label": "City",
      "placeholder": "e.g. Putrajaya"
    },
    "state": {
      "label": "State",
      "placeholder": "e.g. Wilayah Persekutuan Putrajaya"
    },
    "country": {
      "label": "Country",
      "placeholder": "e.g. Malaysia"
    }
  },
  "id": {
    "address_1": {
      "label": "Nama Jalan, Gedung, No Rumah, RT/RW, Kelurahan",
      "placeholder": "e.g. Jalan Prof. Joko Sutono Sh No.999, RT.14/RW.6, Petogogan, "
    },
    "address_2": {
      "label": "Kecamatan",
      "placeholder": "Kec. Kby. Baru"
    },
    "postcode": {
      "label": "Kode Pos",
      "placeholder": "12160"
    },
    "city": {
      "label": "Kota",
      "placeholder": "Kota Jakarta Selatan"
    },
    "state": {
      "label": "Provinsi",
      "placeholder": "DKI Jakarta"
    },
    "country": {
      "label": "Country",
      "placeholder": "e.g. Indonesia"
    }
  }
}
</i18n>